export default __webpack_public_path__ + "static/media/blog-img81.e0a9be62.jpg";